import { Theme } from 'ts-core';
import React from 'react';


const ThemeContext = React.createContext<Theme | undefined>(undefined);

export function useTheme() {
    const context = React.useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
}

export function ThemeProvider({ children, theme }: { children: React.ReactNode; theme?: Theme }) {
    return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>;
}